function SmartTabs() {
    return null;
}

export default SmartTabs;